import invoiceTranslations from "@src/modules/client/modules/invoice/_langs/fr-CA";
import transactionTranslations from "@src/modules/client/modules/transaction/_langs/fr-CA";

export default {
  invoice: invoiceTranslations,
  transaction: transactionTranslations,
};
